module.exports = "/fonts/PT Root UI_Medium.woff?00ea4fe5cbb5d1afb74393c13c7257f0";